import { ArticleCard } from '@components/common'
import { Container } from '@components/ui'
import Link from 'next/link'

interface Props {
  slice: any
}
const MoreDocsList = ({ slice }: Props) => {
  const { primary, items } = slice
  const link = primary?.link
  const linkText = primary?.linkText
  const title = primary?.title
  const bgWhite = primary?.backgroundColourWhite

  return (
    <div className={'w-full' + (bgWhite ? 'bg-brand-white' : '')}>
      <Container
        clean={!primary?.insideContainer}
        className="pt-10 pb-20 lg:pt-10 lg:pb-30 "
      >
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
            {title && (
              <div className="heading-mobile-3 lg:heading-3">{title}</div>
            )}
            {link && linkText && (
              <div className="body-1 underline hover:opacity-75">
                <Link href={link} passHref>
                  {linkText}
                </Link>
              </div>
            )}
          </div>
          <div className="grid gap-8 lg:grid-cols-12">
            {items && (
              <>
                {items.map((item: any, index: number) => {
                  const { otherDocs } = item
                  return (
                    <div className="lg:col-span-4" key={index}>
                      <ArticleCard
                        uid={otherDocs?.uid}
                        article={otherDocs?.data}
                      />
                    </div>
                  )
                })}
              </>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default MoreDocsList
